import React from 'react';
import { trans } from '../../../localization/language';
import { VERIFICATION_TOOL } from '../../../constants';

export default class AlternativeTools extends React.Component {

	render() {
	    const toolUIMap = {
            [VERIFICATION_TOOL.MOBILE]: {
                icon: "changepwd-method__item-icon--mobile",
                name: "SMS"
            },
            [VERIFICATION_TOOL.EMAIL]: {
                icon: "changepwd-method__item-icon--email",
                name: "Email"
            },
            [VERIFICATION_TOOL.AUTHENTICATOR]: {
                icon: "changepwd-method__item-icon--authenticator",
                name: "Authenticator"
            }
	    }
		return (
			<div className="changepwd-method">
			    <div className="changepwd-method__title">{trans('alternative_verification_title')}</div>
			    {
			        this.props.alternativeTools.map(alternativeTool =>
                        <div key={toolUIMap[alternativeTool].name} className="changepwd-method__list">
                            <a href="#" className="changepwd-method__item" onClick={() => this.props.handleChangeTool(alternativeTool)}>
                                <div className={toolUIMap[alternativeTool].icon}></div>
                                <div className="changepwd-method__item-txt">
                                    {toolUIMap[alternativeTool].name}
                                </div>
                            </a>
                        </div>
                    )
			    }
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./app/components/security/verification/AlternativeTools.js